export const API_BASE_URI = import.meta.env.VITE_API_BASE_URI;
export const API_SUBSCRIPTION_KEY = import.meta.env.VITE_API_SUBSCRIPTION_KEY;
export const API_ENDPOINT_PREFIX = import.meta.env.VITE_API_ENDPOINT_PREFIX;
export const API_FX_BASE_URI = import.meta.env.VITE_API_FX_BASE_URI;
export const API_FX_SUBSCRIPTION_KEY = import.meta.env
  .VITE_API_FX_SUBSCRIPTION_KEY;
export const API_FX_ENDPOINT_PREFIX = import.meta.env
  .VITE_API_FX_ENDPOINT_PREFIX;

export const COMMIT_ID = import.meta.env.VITE_COMMIT_ID;
export const DEV_BAR_COLOR = import.meta.env.VITE_DEV_BAR_COLOR;
export const WEBSITE_NAME = import.meta.env.VITE_WEBSITE_NAME;
export const WEBSITE_NAME_SHORT = import.meta.env.VITE_WEBSITE_NAME_SHORT;

export const ADB2C_APPLICATION_ID = import.meta.env.VITE_ADB2C_APPLICATION_ID;
export const ADB2C_INSTANCE = import.meta.env.VITE_ADB2C_INSTANCE;
export const ADB2C_INVITATION_POLICY = import.meta.env
  .VITE_ADB2C_INVITATION_POLICY;
export const ADB2C_MFA_RENEW_POLICY = import.meta.env
  .VITE_ADB2C_MFA_RENEW_POLICY;
export const ADB2C_POLICY = import.meta.env.VITE_ADB2C_POLICY;
const envRedirectUri = import.meta.env.VITE_ADB2C_REDIRECT_URI;
export const ADB2C_REDIRECT_URI =
  envRedirectUri === "dynamic" ? window.location.origin : envRedirectUri;
export const ADB2C_SIGNUP_POLICY = import.meta.env.VITE_ADB2C_SIGNUP_POLICY;
export const ADB2C_SESSION_TRANSFER_POLICY = import.meta.env
  .VITE_ADB2C_SESSION_TRANSFER_POLICY;
export const ADB2C_TENANT = import.meta.env.VITE_ADB2C_TENANT;
export const ADB2C_SCOPE_DOMAIN = import.meta.env.VITE_ADB2C_SCOPE_DOMAIN;
export const ADB2C_SCOPES = [
  `https://${ADB2C_SCOPE_DOMAIN}/${ADB2C_APPLICATION_ID}/general`,
];

export const MEIRO_CDP_BASE_URI = import.meta.env.VITE_MEIRO_CDP_BASE_URI;

export const DEFAULT_LANGUAGE = import.meta.env.VITE_DEFAULT_LANGUAGE;
export const DISABLE_AUTO_LOGOUT = import.meta.env.VITE_DISABLE_AUTO_LOGOUT;

export const USERCENTRICS_SETTINGS_ID = import.meta.env
  .VITE_USERCENTRICS_SETTINGS_ID;

export const ENABLE_FX_FEATURES: boolean =
  import.meta.env.VITE_ENABLE_FX_FEATURES === "yes";

export const ENABLE_ACCOUNT_PAYABLES: boolean =
  import.meta.env.VITE_ENABLE_ACCOUNT_PAYABLES === "yes";

export const ENABLE_ACCOUNT_RECEIVABLES: boolean =
  import.meta.env.VITE_ENABLE_ACCOUNT_RECEIVABLES === "yes";

export const TRANSACTIONS_EXPORT_LIMIT: number = import.meta.env
  .VITE_TRANSACTIONS_EXPORT_LIMIT as number;

export const CARD_SENSITIVE_REVEAL_TTL_MS = import.meta.env
  .VITE_CARD_SENSITIVE_REVEAL_TTL_MS;

// Expenses promotion
export const EXPENSES_URL = import.meta.env.VITE_EXPENSES_URL;
export const EXPENSES_LOGIN_URL = import.meta.env.VITE_EXPENSES_LOGIN_URL;

export const ENABLE_MOCK_BANKS: boolean =
  import.meta.env.VITE_ENABLE_MOCK_BANKS === "yes";

// Lokalise in-context editor
export const LOKALISE_PROJECT_ID = import.meta.env.VITE_LOKALISE_PROJECT_ID;
export const LOKALISE_IN_CONTEXT_EDITOR_ENABLED: boolean =
  import.meta.env.VITE_LOKALISE_IN_CONTEXT_EDITOR_ENABLED === "yes";

// FlowPay Secure Embed
export const FLOWPAY_EMBED_URL = import.meta.env.VITE_FLOWPAY_EMBED_URL;
export const FLOWPAY_PARTNER_CODE = import.meta.env.VITE_FLOWPAY_PARTNER_CODE;

// Demo mode installs the mock API + stubbed MSAL. Normally it's switched on by
// building with `--mode demo` (VITE_DEMO_MODE=yes). As a safety net we ALSO turn
// it on for any *.vercel.app preview: those hosts only ever serve the public
// demo, and if Vercel happens to build in the wrong mode the app would
// otherwise fall into the real-MSAL path and hang forever on the splash.
// Local dev (localhost) is unaffected and keeps talking to the real dev API.
export const DEMO_MODE: boolean =
  import.meta.env.VITE_DEMO_MODE === "yes" ||
  (typeof window !== "undefined" &&
    window.location.hostname.endsWith(".vercel.app"));

// PayU card widget
export const PAYU_POS_ID = import.meta.env.VITE_PAYU_POS_ID;
